import { getLogoutUseCase } from '@/di';
import { useActionTypeModal } from '@/features/actionType/hooks/useActionTypeModal.hook';
import { useAuthStore, useNotificationStore } from '@/shared/stores';
import { useNavigate } from 'react-router-dom';
import type { UserProfile } from '../models/navbar.model';
import { useNotificationsModal } from './useNotificationsModal';
import { authPersistenceService } from '@/infra';

export const useNavbarProfile = () => {
  const name = useAuthStore((state) => state.name);
  const email = useAuthStore((state) => state.email);
  const resetNotificaion = useNotificationStore((state) => state.reset);

  const navigate = useNavigate();
  const actionTypeModal = useActionTypeModal();
  const notificationsModal = useNotificationsModal();

  const userProfile: UserProfile = {
    name: name || 'Sin usuario',
    email: email || 'Sin email',
  };

  const menuActions = new Map([
    ['configuracion', () => navigate('/configuracion', { replace: true })],
    ['usuario', () => navigate('/usuario', { replace: true })],
    ['tipos-acciones', () => actionTypeModal.openModal()],
    ['mensajes', () => notificationsModal.openModal()],
    [
      'cerrar-sesion',
      async () => {
        await getLogoutUseCase().execute();
        navigate('/login', { replace: true });

        setTimeout(() => {
          // resetea el store de las notificaciones
          resetNotificaion();
          authPersistenceService.clearAllAppData();
        }, 500);
      },
    ],
  ]);

  const handleMenuAction = (key: string) => {
    const action = menuActions.get(key);
    if (!action) {
      console.warn(`No se ha encontrado acciones para ${key}`);
      return;
    }

    action();
  };

  const handleLogout = () => handleMenuAction('cerrar-sesion');

  return {
    userProfile,
    handleLogout,
    handleMenuAction,
    notificationsModal,
    actionTypeModal,
  };
};
